import React, { Suspense } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IRoute } from '../entities/interfaces/route';
import ApplicationLayout from '../layouts/ApplicationLayout/ApplicationLayout.lazy';

const RouteWithSubRoutes = ( route: IRoute ) => {
    /** Authenticated flag */
    const authenticated = false;
    
    return (
        <Suspense fallback={route.fallback}>
            <Route
                path={route.path}
                render={( props ) => (
                    <ApplicationLayout>
                        {route.redirect ? <Redirect to={route.redirect} /> :
                        route.private ? (
                        authenticated ? route.component &&
                        <route.component {...props} routes={route.routes} /> : <Redirect to='/error404' />
                        ) : route.component && <route.component {...props} routes={route.routes} />}
                    </ApplicationLayout>
                )}
            />
        </Suspense>
    );
};

export default RouteWithSubRoutes;